import axios from "axios";
import { Supplier_api } from "../../../../Apiconfig";


// Function to handle search
export const searchPro = async (searchText) => {
	try {
		const response = await axios.get(
			`${Supplier_api}search_product.php?searchText=${searchText}`,
			{
				withCredentials: true,
			}
		);
		if (response.status === 200) {
			return response.data;
		} else {
			alert("Error: " + response.data.message);
		}
	} catch (error) {
		console.error(error);
	}
};
